import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system"

const baseStyle = defineStyle({
  borderRadius: "4px",
  fontSize: "sm", // FIXME: Doesn't apply for some reason
  fontWeight: "medium",
  _hover: {
    textDecoration: "underline",
  },
})

const variants = {
  solid: {
    backgroundColor: "black",
    color: "white",

    // No special hover effects
    _hover: {
      backgroundColor: "black",
    },
  },
  secondary: {
    backgroundColor: "blackAlpha.100",
    color: "black",
    border: "none",

    // No special hover effects
    _hover: {
      backgroundColor: "blackAlpha.100",
    },
  },
  outline: {
    backgroundColor: "transparent",
    color: "black",
    borderColor: "blackAlpha.800",
    borderWidth: "1px",

    // No special hover effects
    _hover: {
      backgroundColor: "transparent",
    },
  },
};

export const Button = defineStyleConfig({
  baseStyle,
  variants,
});
